import { useState, useEffect } from "react";

export function useTheme() {
  const [darkTheme, setDarkTheme] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setDarkTheme(savedTheme === "dark");
    } else {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      setDarkTheme(prefersDark);
    }
  }, []);

  const toggleTheme = () => {
    const newDark = !darkTheme;
    setDarkTheme(newDark);
    localStorage.setItem("theme", newDark ? "dark" : "light");
  };

  return [darkTheme, toggleTheme];
}
